import { useEffect } from 'react';
import {
    useLocation,
    useNavigate,
    useParams
  } from "react-router-dom";

export const withGradOfficeDefaultRoute = (Component) =>  {
    const WithGradOfficeDefaultRouteWrapper = (props) => {
		const location = useLocation();
		const navigate = useNavigate();
		const params = useParams();
		const match = {
			path: location.pathname
		};
		
		useEffect(() => {
			// if the default page has been requested
			var defaultRegex = /\/gradoffice$/i;
			if (defaultRegex.test(match.path)) {
				navigate('/GradOffice/Home', { replace: true });
			}
		});
		
		return (
			<Component
				location={location}
				navigate={navigate}
				params={params}
				match={match}
				{...props}
			/>
		);
    }
    return WithGradOfficeDefaultRouteWrapper;
}
